import React, { useState } from "react";
import { Box, IconButton, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";

import Iconify from "src/components/iconify";

export default function VideoPlayer({
  src,
  alt,
}: {
  src: string;
  alt: string;
}) {
  const [isPlaying, setIsPlaying] = useState(false);
  const videoRef = React.useRef<HTMLVideoElement | null>(null);

  const handlePlayPause = () => {
    if (!videoRef.current) return;

    if (isPlaying) {
      videoRef.current.pause();
    } else {
      videoRef.current.play();
    }

    setIsPlaying(!isPlaying);
  };

  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        maxWidth: 800,
        // height: 450,
        borderRadius: 2,
        overflow: "hidden",
        boxShadow: (theme) =>
          `0 8px 16px ${alpha(theme.palette.grey[900], 0.5)}`,
      }}
    >
      {/* Video Element */}
      <video
        ref={videoRef}
        src={src}
        style={{ width: "100%", objectFit: "cover" }}
        onClick={handlePlayPause}
        loop
      />

      {/* Overlay */}
      {!isPlaying && (
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: alpha("#000", 0.6),
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1,
          }}
        >
          <IconButton
            onClick={handlePlayPause}
            sx={{
              color: "white",
              fontSize: 180,
              "&:hover": { transform: "scale(2.5)" },
              transition: "transform 0.2s ease",
            }}
          >
            <Iconify icon="icon-park-solid:play" />
          </IconButton>
        </Box>
      )}

      {/* Pause Button (if playing) */}
      {isPlaying && (
        <Box
          sx={{
            position: "absolute",
            top: 10,
            right: 10,
            zIndex: 2,
          }}
        >
          <IconButton
            onClick={handlePlayPause}
            sx={{
              color: "white",
              fontSize: 100,
              backgroundColor: alpha("#000", 0.6),
              "&:hover": { backgroundColor: alpha("#000", 0.8) },
              transition: "background-color 0.2s ease",
            }}
          >
            <Iconify fontSize={140} icon="gridicons:pause" />
          </IconButton>
        </Box>
      )}

      {/* Alt Text Fallback */}
      <Typography
        sx={{
          position: "absolute",
          bottom: 10,
          left: 10,
          color: "white",
          zIndex: 2,
          backgroundColor: alpha("#000", 0.6),
          padding: "2px 8px",
          borderRadius: 1,
          fontSize: 12,
        }}
      >
        {alt}
      </Typography>
    </Box>
  );
}
